import { getApiUrl } from '~/config';
import { User } from '~/types';
import { getOrCreateAnonymousId } from '~/utils/anonymous';
import { throwApiError } from '~/utils/apiError';

/**
 * Get the current User.
 *
 * @throws Error on API request failure.
 */
export const whoami = async (): Promise<User> => {
  const apiUrl = getApiUrl();
  const response = await fetch(`${apiUrl}/me`, {
    headers: {
      'X-Anonymous-ID': getOrCreateAnonymousId()
    },
    // This ensures cookies are sent with the request.
    credentials: 'include'
  });
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

/**
 * Update the nickname of the current User.
 *
 * @throws ValidationError with the backend's message on a 422, or a plain
 * Error otherwise.
 */
export const updateNickname = async (nickname: string): Promise<User> => {
  const apiUrl = getApiUrl();
  const response = await fetch(`${apiUrl}/me`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Anonymous-ID': getOrCreateAnonymousId()
    },
    // This ensures cookies are sent with the request.
    credentials: 'include',
    body: JSON.stringify({ nickname })
  });

  if (!response.ok) {
    await throwApiError(
      response,
      "Sorry, we couldn't update your nickname. Please try again."
    );
  }

  return response.json();
};
